<template>
  <div>
    <label>Optional mappings</label>

    <ListEditor
      :addAttribute="()=>{}"
      :component="$options.OptionalAttributeField"
      :handleChangeListItem="handleChangeAttribute"
      :handleRemoveListItem="handleRemoveAttribute"
      headerText=""
      :listItemClassNameOverride="$style.listItemClassNameOverride"
      :listItems="customIdmOptionalAttributes"
      :removeButtonClassName="$style.removeButton"
      :removeButtonClassOverride="$style.removeButtonClassOverride"
      :showHeader="false"
      :valueDynamicComponentProps="valueDynamicComponentProps"
    />

    <p :class="$style.anchorWrapper">
      <a
        :class="$style.addAttributeAnchor"
        data-test-id="addAttributeAnchor"
        @click="addOptionalMapping"
      >
        + Add attribute
      </a>
    </p>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { suggestedAttrInitalOrder } from 'client/util/Constants/ApplicationConstants';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import ListEditor from 'client/components/FormValidation/ListEditor.vue';
import OptionalAttributeField from 'client/applications/scim/customConnector/OptionalAttributeField.vue';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'OptionalAttributesMapping',

  components: {
    ListEditor,
  },

  mixins: [IdentityManagementMixin],

  OptionalAttributeField,

  computed: {
    ...mapGetters(applicationModel, [
      'customIdmOptionalAttributes',
    ]),
    /**
     * Get array of unused attributes to pass to dropdown menu on ListEditor
     */
    getUnusedAttributes() {
      const attributes = this.getOptionalAttributes;

      if (this.customIdmOptionalAttributes.length === 0) return attributes;

      const targetAttributes = this.customIdmOptionalAttributes
        .map(usedAttribute => usedAttribute.jcAttribute);

      return attributes
        .filter(optAttribute => !targetAttributes.includes(optAttribute.attribute));
    },

    valueDynamicComponentProps() {
      return {
        dropdownOptions: this.getUnusedAttributes,
      };
    },
  },

  async mounted() {
    if (!this.isScimActive && this.customIdmOptionalAttributes.length === 0) {
      this.addSuggestedOptionalMappings();
    }
  },

  methods: {
    ...mapActions(applicationModel, {
      addOptionalMapping: 'addCustomApiOptionalMapping',
      removeOptionalMapping: 'removeCustomApiOptionalMapping',
      updateOptionalMapping: 'updateCustomApiOptionalMapping',
    }),

    addSuggestedOptionalMappings() {
      const unusedAttributes = [...this.getUnusedAttributes];

      return suggestedAttrInitalOrder.forEach(attr => {
        const unusedOption = unusedAttributes.find(option => option.attribute === attr);
        if (unusedOption) {
          this.addOptionalMapping({
            jcAttribute: unusedOption.attribute,
          });
        }
      });
    },

    /**
     * @param {String} value New value for the attribute
     * @param {String} key Specifies which field [_spAttribute_ | _jcAttribute_] is being updated
     */
    handleChangeAttribute(index, value, key) {
      //  Make copy of target mapping
      const updatedMapping = { ...this.customIdmOptionalAttributes[index] };

      if (key === 'jcAttribute') {
        Object.assign(updatedMapping, { jcAttribute: value });
      } else {
        Object.assign(updatedMapping, { spAttribute: value });
      }

      this.updateOptionalMapping(updatedMapping);
    },

    handleRemoveAttribute(_index, item) {
      const { _id } = item;
      this.removeOptionalMapping(_id);
    },
  },
};
</script>

<style module>
@import '../css/IdentityManagementCommon.css';

.anchorWrapper {
  margin: 0.5rem 0;
}

.removeButtonClassOverride {
  flex: 1;
}

.removeButton:hover {
  cursor: pointer;
}
</style>
